import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";

const resources = {
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
};

// Helper function to normalize language code
// Converts backend format ("spanish", "english") to frontend format ("es", "en")
const normalizeLanguage = (lang) => {
  if (!lang) return null;
  const normalized = lang.toLowerCase();
  if (normalized === "spanish" || normalized === "es" || normalized.startsWith("es-")) {
    return "es";
  }
  if (normalized === "english" || normalized === "en" || normalized.startsWith("en-")) {
    return "en";
  }
  return null;
};

const storedLanguageRaw = localStorage.getItem("preferred_language");
const storedLanguage = normalizeLanguage(storedLanguageRaw);

const getBrowserLanguage = () => {
  if (typeof window === "undefined") return "en";
  const browserLang = navigator.language || navigator.userLanguage;
  const allLanguages = navigator.languages || [browserLang];
  
  console.log("🌐 Browser Language Detection:", {
    "navigator.language": navigator.language,
    "navigator.userLanguage": navigator.userLanguage,
    "navigator.languages": navigator.languages,
    "primary detected": browserLang
  });
  
  if (browserLang) {
    const primaryLang = browserLang.toLowerCase();
    if (primaryLang.startsWith("es")) {
      console.log("   ✅ Primary language is Spanish");
      return "es";
    }
    if (primaryLang.startsWith("en")) {
      console.log("   ✅ Primary language is English");
      return "en";
    }
  }
  
  for (const lang of allLanguages) {
    if (lang && lang.toLowerCase().startsWith("es")) {
      console.log("   ⚠️ Spanish found in languages array (fallback)");
      return "es";
    }
    if (lang && lang.toLowerCase().startsWith("en")) {
      console.log("   ⚠️ English found in languages array (fallback)");
      return "en";
    }
  }
  
  console.log("   ⚠️ No matching language found, defaulting to English");
  return "en";
};

const browserLang = getBrowserLanguage();
const finalLanguage = (storedLanguage && storedLanguage !== "en") ? storedLanguage : 
                      (browserLang === "es" ? browserLang : (storedLanguage || browserLang));

if (browserLang === "es" && (!storedLanguageRaw || storedLanguage === "en")) {
  if (typeof window !== "undefined") {
    localStorage.setItem("preferred_language", "es");
    console.log("💾 Auto-saving browser language 'es' to localStorage");
  }
}

console.log("🔧 i18n Initialization:", {
  "localStorage (raw)": storedLanguageRaw,
  "localStorage (normalized)": storedLanguage,
  "browser language": browserLang,
  "final language": finalLanguage,
  "auto-saved": browserLang === "es" && (!storedLanguageRaw || storedLanguage === "en")
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common"],
    lng: finalLanguage,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "preferred_language",
      checkWhitelist: true,
      excludeCacheFor: ["cimode"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  console.log("✅ i18n Language Changed:", lng);
});

console.log("✅ i18n Initialized with language:", i18n.language);

export const supportedLanguages = [
  { code: "en", labelKey: "header.languageEnglish" },
  { code: "es", labelKey: "header.languageSpanish" },
];

export default i18n;

